<template>
  <div class="input-list">
    <a-form-item
      v-for="(item, index) in list"
      :key="item._id"
      :label="item.fieldname"
      class="input-box clearfix"
      :class="{
        'en-input-box': isEnglish,
        'next-box': index,
        'isrepeatsave': item.isrepeat && item.isrepeatsave
      }"
    >
      <span
        v-decorator="[`${item.fieldkey}-${index}`, {
          validateTrigger: ['blur'],
          rules: [{
            required: item.isneeded === 1,
            message: placeholder
          }, {
            validator: validateRepeat
          }, {
            validator: checkEmail
          }],
          initialValue: item.fieldvalue
        }]"
        class="input"
      >
        <a-input
          v-model="item.fieldvalue"
          :placeholder="placeholder"
          :disabled="item.disabled"
          @change="handleChange($event, item, index)"
          @blur="handleBlur(index)"
        />
      </span>
      <i
        v-if="index"
        class="iconfont iconicon-test8 del-icon"
        @click="handleDelete(index)"
      />
      <a
        v-if="item.isrepeat && item.is_show_view"
        href="javascript:;"
        class="look-repeat-btn"
        @click="handleClickRepeat(index)"
      >{{ $t('message["85"]') }}</a>
    </a-form-item>
    <a
      v-if="!isClue"
      class="fs-blue add-btn"
      @click="handleAdd"
    >
      {{ $t('message["1561"]') }}
    </a>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { checkRepeat } from '@/services/inqueryServices'
import { getLang } from '@/lib/storage'
import { checkClueFieldRepeat } from '@/services/clue'
export default {
  name: 'InputList',

  inject: {
    myForm: {
      default: () => { }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    },
    parentKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: '',
      list: [],
      currentIndex: null,
      source: []
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['repeatSaveItems']),
    inquiryId () {
      return this.$route.params.inquiryId || this.$route.params.id
    },
    pid () {
      return this.$route.params.pid
    },
    repeatTip () {
      // 存在重复信息
      return this.$t('message["134"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    isClue () {
      return this.$route.name === 'ClueCreate' || this.$route.name === 'ClueDetail'
    }

  },

  created () {
    this.value = this.data.fieldvalue
    this.setList()
  },

  destroyed () {
    this.UPDATE_REPEAT_SAVE_ITEMS({})
  },

  methods: {
    ...mapMutations('inquery/detailData', ['UPDATE_REPEAT_SAVE_ITEMS']),
    getLang,

    handleChange (e, item, index) {
      const { fieldtype = '', fieldkey } = this.data || {}
      let val = e.target.value
      if (fieldtype === 'email') {
        val = this.filterOutChinese(val).toLowerCase()
      }

      if (val === '') {
        this.list[index].isrepeat = 0
        this.list[index].is_show_view = 0
        this.list[index].isrepeatsave = 0
        this.repeatSaveItems[fieldkey] = 0
        this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, this.repeatSaveItems))
      }

      item.fieldvalue = val.replace(/\s*/g, '')
      this.value = this.list.map(item => item.fieldvalue)
      this.data.fieldvalue = this.value
      this.$emit('change', this.value)
      this.$forceUpdate()
    },

    handleBlur (index) {
      let { fieldkey = '' } = this.data || {}
      this.currentIndex = index
      for (let i = 0; i < this.list.length; i++) {
        this.myForm && this.myForm.setFieldsValue({
          [`${fieldkey}-${i}`]: this.value[i]
        })
      }
      this.myForm && this.myForm.validateFields()
    },

    setList () {
      let { value = [], data = {} } = this
      if (!value.length) {
        value = ['']
      }
      this.list = value.map(item => {
        let obj = { ...data }
        obj.fieldvalue = item || ''
        obj.isEmailError = false // 邮箱格式不正确
        obj.isrepeat = 0
        obj.is_show_view = 0
        obj.isrepeatsave = 0
        return obj
      })
    },

    handleAdd () {
      let obj = { ...this.data }
      obj._id = Math.random() * Math.pow(10, 18)
      obj.fieldvalue = ''
      obj.isEmailError = false
      obj.isrepeat = 0
      obj.is_show_view = 0
      obj.isrepeatsave = 0
      obj._id = Math.random() * Math.pow(10, 18)
      this.list.push(obj)
      this.value = this.list.map(item => item.fieldvalue)
      this.data.fieldvalue = this.value
      this.$emit('change', this.value)

      this.handleBlur()
    },

    handleDelete (index) {
      this.list.splice(index, 1)
      this.value = this.list.map(item => item.fieldvalue)
      this.data.fieldvalue = this.value
      this.$emit('change', this.value)

      this.handleBlur()
    },

    async validateRepeat (rule, value, callback) {
      const { fieldkey = '', fieldrepeat = 0 } = this.data || {}
      let currentIndex = this.value.findIndex(item => item === value)

      if (!value || !fieldrepeat || currentIndex === -1) {
        callback()
        return
      }

      const { isEmailError } = this.list[currentIndex]
      // let res = await checkRepeat().params({
      //   inquiryid: this.inquiryId,
      //   fieldkey,
      //   fieldvalue: value
      // }).fetch()
      let res = null
      if (this.isClue) {
        res = await checkClueFieldRepeat().params({
          clue_id: this.inquiryId,
          fieldkey: this.parentKey + '.' + fieldkey,
          fieldvalue: value
        }).fetch()
      } else {
        res = await checkRepeat().params({
          inquiryid: this.inquiryId,
          fieldkey,
          fieldvalue: value
        }).fetch()
      }

      const { payload = {} } = res && res.data
      const { isrepeat = 0, is_show_view: isShowView = 0, isrepeatsave = 0, source = '' } = payload

      this.list[currentIndex].isrepeat = !isEmailError && isrepeat
      this.list[currentIndex].is_show_view = isShowView
      this.list[currentIndex].source = source
      this.list[currentIndex].isrepeatsave = isrepeat && isrepeatsave
      this.$forceUpdate()

      let repeatSaveItems = {
        ...this.repeatSaveItems,
        [`${fieldkey}-${currentIndex}`]: isrepeat && isrepeatsave
      }
      this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, repeatSaveItems))

      if (!isEmailError && value && isrepeat) {
        // rule.message = '存在重复信息'
        rule.message = this.$t('message["134"]')
        callback(rule.message)
      } else {
        callback()
      }
    },

    checkEmail (rule, value, callback) {
      const { fieldtype, fieldkey } = this.data
      let currentIndex = this.value.findIndex(item => item === value)

      if (fieldtype !== 'email' || value === '' || value === undefined) {
        callback()
        return
      }
      if (currentIndex === -1) {
        callback()
        return
      }

      if (!/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,64}$/.test(value)) {
        // rule.message = '邮箱不是有效的邮箱格式'
        rule.message = this.$t('message["1508"]')
        this.list[currentIndex].isEmailError = true
        let repeatSaveItems = {
          ...this.repeatSaveItems,
          [`${fieldkey}-${currentIndex}`]: 0
        }
        this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, repeatSaveItems))
        callback(rule.message)
      } else {
        rule.message = ''
        this.list[currentIndex].isEmailError = false
        callback()
      }
    },

    filterOutChinese (str) {
      var temp = ''
      for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) > 0 && str.charCodeAt(i) < 255) || str[i] === '，') {
          temp += str.charAt(i)
        }
      }
      return temp
    },

    handleClickRepeat (index) {
      const { fieldkey } = this.data
      const fieldvalue = this.value[index]
      let href = ''
      if (this.list[index].source === 'clue') {
        const { parentKey } = this
        href = `${location.origin}/project/${this.pid}/inquery/clue?search_type=${parentKey}.${fieldkey}&kwd=${fieldvalue}`
      } else {
        href = `${location.origin}/project/${this.pid}/inquery/repeat?repeatfieldkey=${fieldkey}&repeatfieldvalue=${fieldvalue}`
      }

      let tempwindow = window.open()
      tempwindow.location = href
    }
  }
}
</script>

<style lang="scss" scoped>
.next-box ::v-deep {
  .ant-form-item-label {
    display: none;
  }
}
.input-box ::v-deep {
  .wrap {
    position: relative;
  }
  .del-icon {
    margin-left: 5px;
    color: #ccc;
  }
  .look-repeat-btn {
    position: absolute;
    left: 90px;
    top: 30px;
    font-size: 13px;
    line-height: 1;
  }
  .ant-form-explain {
    margin-top: 3px;
    font-size: 13px;
  }
}
.en-input-box::v-deep {
  .look-repeat-btn {
    left: 200px !important;
  }
}
.isrepeatsave ::v-deep {
  .has-error .ant-form-explain {
    color: #f6a953;
  }
}
.add-btn {
  display: block;
  width: 60px;
  margin: 0 0 24px 140px;
}
</style>
